module.exports = __webpack_public_path__ + "img/totalgateway2.0d350992.png";